import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import Header from './components/Header'
import Section from './components/Section'


const App = () => {

 
  return (
    <>
      {/* <Search/> */}
        <Header/>
        <Section/> 
      
    </>
  )
}

export default App